// Previous version
// var fn_img_target_blank =  $('a[target=_blank]').each(function() {
//     if ($(this).find("img").length > 0) {
//         $(this).addClass('no-after');
//     }
// })

// When the link wraps an image, we add a class to display-none its ::after, so that the icon does not show
var fn_img_target_blank = function() {
    $('a[target=_blank] img').each(function() {
        $(this).closest("a").addClass('no-after');
    })
}